import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Login from './component/Login/Login';
import IncompleteOrderForm from './component/AddOrder/AddIncompleteOrderForm';
import AddOrderLandingPage from './component/AddOrder/AddOrderLandingPage';
import LandingPage from './component/AddingMedToOrder/LandingPage';
import ShowAddedMedicines from './component/AddingMedToOrder/ShowAddedMedicines';
import FetchIncompleteOrderList from './component/FetchOrderList/FetchIncompleteOrderList';
import FetchOrderList from './component/FetchOrderList/FetchOrderList';
import Order from './component/FetchOrderList/Order';
import FetchAllUsers from './component/Users/FetchAllUsers';
import User from './component/Users/Users';
import Partner from './component/Partners/Partners';
import MedicinesList from './component/AllMedicines/MedicinesList';
import ManagePartners from './component/Partners/AllPartners';
import DoctorList from './component/Doctors/AllDoctors';
import PartnerDashboard from './component/Partners/DetailedPartnerDashboard';
import Admin from './component/Admin/Admin';
import MsgOptPage from './component/MsgOptPage/MsgOptPage';
import RefillManagementLandingPage from './component/RefillManagementSystem/RefillManagementLandingPage';
import DispatchingSystemLandingPage from './component/DispatchingSystem/DispatchingSystemLandingPage';
import InventoryLandingPage from './component/Inventory/InventoryLandingPage';
import MedicinesPage from './component/Inventory/MedicinesPage';
import Overview from './component/Analytics/Overview';
import AddNonRxLandingPage from './component/AddingNonRxMedicines/AddNonRxLadingPage';
import CartridgeChange from './component/CartridgeChange';

import './App.css';

class App extends Component {
    render() {
        return (

            <Router>
                <Switch>
                    <Route path="/login" component={Login} />
                    <Route path="/sign-up" component={MsgOptPage} />
                    <Route path="/change_cartridge" component={CartridgeChange} />

                    <Admin>
                        <Route path="/addIncompleteOrder" component={IncompleteOrderForm} />
                        <Route path="/addOrder" component={AddOrderLandingPage} />
                        <Route path="/addMedOrder" component={LandingPage} />
                        <Route path="/inCompleteOrders" component={FetchIncompleteOrderList} />
                        <Route path="/allOrders" component={FetchOrderList} />
                        <Route path="/orders/:id" component={Order} />
                        <Route path="/showAddedMed" component={ShowAddedMedicines} />
                        <Route path="/allUsers" component={FetchAllUsers} />
                        <Route path="/users/:id" component={User} />
                        <Route path="/partners/:id" component={Partner} />
                        <Route path="/allMedicines" component={MedicinesList} />
                        <Route exact path="/managePartners" component={ManagePartners} />
                        <Route path="/managePartners/:id" component={PartnerDashboard} />
                        <Route exact path="/doctors" component={DoctorList} />
                        <Route path="/refillManagementSystem" component={RefillManagementLandingPage} />
                        <Route exact path="/inventory" component={InventoryLandingPage} />
                        <Route exact path="/inventory/:order_id" component={MedicinesPage} />
                        <Route path="/dispatching" component={DispatchingSystemLandingPage} />
                        <Route path="/analytics" component={Overview} />

                        <Route path="/addNonRxMedicine" component={AddNonRxLandingPage} />
                    </Admin>

                </Switch>
            </Router>

        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js